'use strict';

var _flickityAsNavFor = require('flickity-as-nav-for');

var _flickityAsNavFor2 = _interopRequireDefault(_flickityAsNavFor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initProductGallery = function initProductGallery() {
  var galleryEl = document.querySelector('[data-product-gallery]');
  if (!galleryEl) return;

  var gallerySlider = new _flickityAsNavFor2.default('[data-product-gallery]', {
    imagesLoaded: true,
    lazyLoad: true,
    pageDots: false,
    prevNextButtons: true,
    arrowShape: 'M34.4,84.8a3.7,3.7,0,0,1-2.3-1L1,52.6a.2.2,0,0,1-.2-.2h0A3,3,0,0,1,0,50.8v-.7a4,4,0,0,1,.9-2h0L32.1,16.9a3.2,3.2,0,0,1,4.6,0,3.2,3.2,0,0,1,.9,2.3,3.1,3.1,0,0,1-.9,2.2L11,47.1H96.8a3.3,3.3,0,0,1,0,6.5H11L36.7,79.3a3.3,3.3,0,0,1,0,4.5A3.4,3.4,0,0,1,34.4,84.8Z'
  });

  window.productGallerySlider = gallerySlider;

  var nav = new _flickityAsNavFor2.default('[data-product-thumbnails]', {
    imagesLoaded: true,
    lazyLoad: true,
    asNavFor: '[data-product-gallery]',
    pageDots: false,
    prevNextButtons: false,
    contain: true
  });
};

document.addEventListener('DOMContentLoaded', function () {
  initProductGallery();
});

document.addEventListener('shopify:section:load', function () {
  initProductGallery();
});